import { Component, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";

@Component({
  selector: "app-login-page",
  templateUrl: "./login-page.component.html",
  styleUrls: ["./login-page.component.scss"],
})
export class LoginPageComponent implements OnDestroy {
  private onDestroy$ = new Subject<void>();

  constructor(private router: Router) {}

  /**
   * Cleanup subscriptions on destroy.
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  /**
   * Navigates to the landing page when the embedded login form reports a successful login.
   * @param event Whether the login attempt succeeded
   */
  public loginFormSubmit(event: boolean): void {
    if (event) {
      this.router.navigate(["landing"]);
    }
  }
}
